// Import the functions you need from the SDKs you need
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { IS_WEB } from "./config";
import { getLogger } from "./logging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBhjMps8PRy3C93GsYGIzaZal_MHt7s1vs",
  authDomain: "chat-noir-hexagon.firebaseapp.com",
  projectId: "chat-noir-hexagon",
  storageBucket: "chat-noir-hexagon.appspot.com",
  messagingSenderId: "364850725471",
  appId: "1:364850725471:web:0d9fee53228133a01e51ea",
  measurementId: "G-QT6GMTCE3W",
};

const log = getLogger("🔥 Firebase");

// Initialize Firebase
export async function initFirebase() {
  if (IS_WEB) {
    initializeApp(FIREBASE_CONFIG);
    // if (__DEV__) {
    //   const db = getFirestore();
    //   connectFirestoreEmulator(db, "localhost", 8081);
    //   log.debug("Connected to Firestore emulator");
    // }
  }
}
